
// Compile our scss
// This 'includes' the SCSS index file which webpack then reads and 
// compiles into the necessary css files
require('../scss/index.scss');
require('./components/homepage-slider.js');
require('./components/google-map.js');
require('./components/forms.js');
require('./global/effects.js');
require('./global/content-video-embeds.js');
require('./components/image-slider.js'); 
require('./components/responsive-images.js');
require('./components/salesforce-html.js');